import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import {
  gradientBackgrounds,
  partialLinearGradient,
} from "../AiComponents.style";

export const aiChipRootCss = (
  variant: "filter" | "input",
  active?: boolean,
): CSSObject => ({
  background:
    variant === "input"
      ? gradientBackgrounds[100]
      : active
        ? gradientBackgrounds[100]
        : constants.colors.ui.white[700],
  color: constants.colors.ui.neutral[700],
  position: "relative",
  borderRadius: "100px",
  zIndex: 1,
  ...(variant === "input"
    ? { border: "none" }
    : active
      ? { border: "1px solid transparent" }
      : undefined),
  "&:hover, &:focus-visible": {
    background: gradientBackgrounds[100],
  },
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "inherit",
    padding: active ? "2px" : "1px",
    background: partialLinearGradient,
    WebkitMask:
      "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    maskComposite: "exclude",
    pointerEvents: "none",
    zIndex: 0,
  },
  span: {
    maxWidth: "190px",
  },
});
